import { USER_PROFILE_KEY_LENGTH_MAX, USER_PROFILE_VALUE_LENGTH_MAX } from '../constants';
import { outputErrorMessage } from './error-message';
import { validateValue } from '../validators/base-validator';
import { UserProfileType } from './user-profile.types';

const validateKey = (key: string): boolean => {
  const [result, error] = validateValue(key, {
    type: 'string',
    denyStandardPrefix: true,
    denyEmptyString: true,
    maxStringLength: USER_PROFILE_KEY_LENGTH_MAX,
  });
  if (!result) {
    outputErrorMessage(error, key, {
      subject: `custom user profile key "${key}"`,
      maxStringLength: USER_PROFILE_KEY_LENGTH_MAX,
    });
    return false;
  }
  return true;
};

export const validateCustomUserProfile = (type: UserProfileType, key: string, value: any): boolean => {
  if (!validateKey(key)) return false;

  let result;
  let error;

  switch (type) {
    case 'string':
      [result, error] = validateValue(value, {
        type: 'string',
        maxStringLength: USER_PROFILE_VALUE_LENGTH_MAX,
      });
      break;
    case 'int':
      [result, error] = validateValue(value, {
        type: 'int',
      });
      break;
    case 'decimal':
      [result, error] = validateValue(value, {
        type: 'double',
      });
      break;
    case 'datetime':
      [result, error] = validateValue(value, {
        type: 'date',
      });
      break;
    default:
      return false;
  }

  if (!result) {
    outputErrorMessage(error, key, {
      subject: `value "${value}"`,
      maxStringLength: USER_PROFILE_VALUE_LENGTH_MAX,
    });
    return false;
  }

  return true;
};
